<form (submit)="generateContract()">
  <div>
    <h2 mat-dialog-title>Generate Contract</h2>
    <mat-dialog-content style="background-color:lightgray;padding-bottom: 20px">
      <div class="container" style="width: 100vw">

        <mat-card class="form-card">
          <div class="row">
            <div class="col-sm-6  col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Price Term({{priceType[market]}})</mat-label>
                <mat-select required [(ngModel)]="priceTerm" name="priceTerm" (ngModelChange)="changePrice()">
                  <mat-option [value]="row" *ngFor="let row of termPriceList">{{row.term}} Months
                    - {{row.price}}</mat-option>

                </mat-select>


              </mat-form-field>
            </div>

            <div class="col-sm-6 c col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Broker Fee({{priceType[market]}})</mat-label>
                <input matInput [(ngModel)]="brokerFee" name="brokerFee" required (ngModelChange)="changePrice()"
                       type="number" >
              </mat-form-field>
            </div>
            <div class="col-sm-6 c col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Price({{priceType[market]}})</mat-label>
                <input matInput [(ngModel)]="price" name="price" required disabled>
              </mat-form-field>
            </div>
            <div class="col-sm-6 c col-lg-3" *ngIf="market === 'ERCOT'">
              <mat-form-field appearance="outline">
                <mat-label>Tax Exempt</mat-label>
                <mat-select [(ngModel)]="taxExempt" name="taxExempt" required>
                  <mat-option [value]="'Yes'">Yes</mat-option>
                  <mat-option [value]="'No'">No</mat-option>
                </mat-select>
              </mat-form-field>
            </div>


          </div>
        </mat-card>
        <mat-divider></mat-divider>
        <mat-card class="form-card">

          <div class="row" style="margin-top: 20px">
            <div class="col-sm-6  col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Broker</mat-label>
                <input matInput [(ngModel)]="broker" name="broker" required>
              </mat-form-field>
            </div>


            <div class="col-sm-6  col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Customer Name</mat-label>
                <input matInput [(ngModel)]="customerName" name="customerName" required>
              </mat-form-field>
            </div>

            <div class="col-sm-6 c col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>DBA</mat-label>
                <input matInput [(ngModel)]="dba" name="dba">
              </mat-form-field>
            </div>

            <div class="col-sm-6 c col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>FederalT ax Id</mat-label>
                <input matInput [(ngModel)]="federalTaxId" name="federalTaxId">
              </mat-form-field>
            </div>

          </div>
        </mat-card>

        <mat-divider></mat-divider>
        <mat-card class="form-card">

          <div class="row" style="margin-top: 20px">
            <div class="col-sm-6  col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Contact Name</mat-label>
                <input matInput [(ngModel)]="contactName" name="contactName">
              </mat-form-field>
            </div>

            <div class="col-sm-6   col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Contact Title</mat-label>
                <input matInput [(ngModel)]="contactTitle" name="contactTitle">
              </mat-form-field>
            </div>

            <div class="col-sm-6  col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Contact Phone</mat-label>
                <input matInput [(ngModel)]="contactPhone" name="contactPhone" (ngModelChange)="phoneChanged(contactPhone)"
                       type="tel"   maxlength="14">
              </mat-form-field>
            </div>
            <div class="col-sm-6   col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Phone Ext</mat-label>
                <input matInput [(ngModel)]="phoneExt" name="phoneExt">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6   col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Contact Email</mat-label>
                <input matInput [(ngModel)]="contactEmail" name="contactEmail" type="email"
                       pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"  >
              </mat-form-field>
            </div>
          </div>
        </mat-card>
        <mat-card class="form-card">
          <div class="row">
            <div class="col-sm-6  col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Street</mat-label>
                <input matInput [(ngModel)]="street" name="street">
              </mat-form-field>
            </div>

            <div class="col-sm-6  col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>City</mat-label>
                <input matInput [(ngModel)]="city" name="city">
              </mat-form-field>
            </div>
            <div class="col-sm-6 col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>State</mat-label>
                <input matInput [(ngModel)]="state" name="state">
              </mat-form-field>
            </div>

            <div class="col-sm-6  col-lg-3">
              <mat-form-field appearance="outline">
                <mat-label>Zip Code</mat-label>
                <input matInput [(ngModel)]="zipCode" name="zipCode"
                       pattern="(\d{5}([\-]\d{4})?)"

                >
              </mat-form-field>
            </div>
          </div>

        </mat-card>
        <mat-card class="form-card">
          <h3 class="mt-2">Facilities:</h3>
          <div *ngIf="market==='PJM' && facility.length > 0">
            <table class="table">
              <tr>
                <th>Account Number</th>
                <th>Service Address</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Bill Option</th>
                <th>Tax Exempt</th>

              </tr>
              <tr *ngFor="let row of facility; let i = index" class="mt-1">
                <td>
                  <input class="form-control input-sm facility" [(ngModel)]="row.accountNumber" required
                         name="accountNumber{{i}}">
                </td>
                <td>
                  <input class="form-control input-sm facility" [(ngModel)]="row.serviceAddress" required
                         name="serviceAddress{{i}}">
                </td>
                <td>
                  <input class="form-control input-sm facility" [(ngModel)]="row.startDate" required
                         name="startDate{{i}}" type="date">
                </td>
                <td>
                  <input class="form-control input-sm facility" [(ngModel)]="row.endDate" required name="endDate{{i}}"
                         type="date">
                </td>
                <td>
                  <select class="form-control input-sm facility" [(ngModel)]="row.billOption" required
                          name="billOption{{i}}">
                    <option [value]="'Dual'">Dual</option>
                    <option [value]="'UCB'">UCB</option>
                  </select>
                </td>
                <td>
                  <select class="form-control input-sm facility" [(ngModel)]="row.taxExempt" required
                          name="taxExempt{{i}}">
                    <option [value]="'Yes'">Yes</option>
                    <option [value]="'No'">No</option>
                  </select>
                </td>

              </tr>
            </table>
          </div>
          <div *ngIf="market==='ERCOT'  && facility.length > 0">
            <div class="row  ">
              <div class="col-lg-12 ">
                <table class="table" style="table-layout: fixed; word-wrap: break-word;">
                  <tr>
                    <th>ESI ID</th>
                    <th>Start Date</th>
                    <th>Service Address</th>
                    <th>Start Date Type</th>
                    <th>Transaction Type <span class="dot" placement="left" [ngbTooltip]="tipTransactionType"> ? </span>
                    </th>
                    <th></th>
                  </tr>
                  <tr *ngFor="let row of facility; let i = index">

                    <td>
                      <input class="form-control input-sm facility" [(ngModel)]="row.accountNumber" required
                             name="accountNumber{{i}}">
                    </td>
                    <td>

                      <input class="form-control input-sm facility" [(ngModel)]="row.startDate" required type="date"
                             name="startDate{{i}}">

                    </td>
                    <td>
                      <input class="form-control input-sm facility" [(ngModel)]="row.serviceAddress" required
                             name="serviceAddress{{i}}">
                    </td>
                    <td>

                      <select class="form-control input-sm facility" [(ngModel)]="row.startDateType" required
                              name="startDateType{{i}}">
                        <option [value]="'READ_DATE'">Read Date</option>
                        <option [value]="'CALENDAR_DATE'">Calendar Date</option>
                      </select>

                    </td>
                    <td>

                      <select class="form-control input-sm facility" [(ngModel)]="row.transactionType" required
                              name="transactionType{{i}}">
                        <option [value]="'SWITCH'">Switch</option>
                        <option [value]="'MOVE_IN'">Move In</option>
                      </select>


                    </td>
                    <td>
                   <span class="float-right" (click)="removeFacility(i)"
                         style="color: red;font-size: 16px;cursor: pointer">X</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <span *ngIf="market==='ERCOT' " (click)="addFacility('')" style="color: dodgerblue ;cursor: pointer">Add Facility</span>
          <br><br><br>
          <br><br><br>
        </mat-card>

      </div>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <span *ngIf="error" style="margin-right: 10%;color: orangered">{{error}}</span>
      <button mat-dialog-close type="button" mat-raised-button style="background-color: #54B4D3;color: white">Cancel
      </button>
      <button *ngIf="downloadProgress==0" mat-raised-button style="background-color: #54B4D3;color: white"
              type="submit">Download
      </button>
      <button *ngIf="downloadProgress > 0" mat-raised-button style="background-color: #54B4D3;color: white"
              type="button">Downloading..
      </button>
    </mat-dialog-actions>

  </div>
</form>


<ng-template #tipTransactionType>Move In:<br>
  (1) Power is currently on (“Energized” or “Active”) but customer is new to that location. <br>
  (2) Power is currently off (“De-Energized”) and the customer needs the power to be turned on.
  <br><br>

  Switch:<br>
  (1) Customer is already occupying the space and has established electricity but wants to change retail energy
  providers.
</ng-template>


<!---[mat-dialog-close]="true"----->
